import Asri1 from "./asri (1).webp";
import Asri2 from "./asri (2).webp";

const asri = [Asri1, Asri2];

export default asri;
